
import { Link } from 'react-router-dom';
import { Building, Building2, Warehouse, Home, ArrowRight } from 'lucide-react';

interface PropertyTypeCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  link: string;
}

const PropertyTypeCard = ({ title, description, icon, link }: PropertyTypeCardProps) => (
  <Link to={link} className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow group h-full">
    <div className="bg-realestate-tag p-3 rounded-full w-14 h-14 flex items-center justify-center text-realestate-blue mb-4 group-hover:bg-realestate-blue group-hover:text-white transition-colors">
      {icon}
    </div>
    <h3 className="text-xl font-semibold mb-2 text-realestate-darkblue">{title}</h3>
    <p className="text-gray-600 mb-4">{description}</p>
    <div className="flex items-center text-realestate-blue font-medium group-hover:translate-x-2 transition-transform">
      View properties
      <ArrowRight className="w-4 h-4 ml-1" />
    </div>
  </Link>
);

const PropertyTypes = () => {
  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-realestate-darkblue mb-2 text-center">Explore by Property Type</h2>
        <p className="text-gray-600 text-center mb-12">Browse commercial properties categorized by their specific use</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <PropertyTypeCard 
            title="Office" 
            description="From high-rise buildings to small offices" 
            icon={<Building className="w-6 h-6" />}
            link="/properties?type=office"
          />
          <PropertyTypeCard 
            title="Retail" 
            description="Storefronts and shopping centers" 
            icon={<Building2 className="w-6 h-6" />}
            link="/properties?type=retail"
          />
          <PropertyTypeCard 
            title="Industrial" 
            description="Warehouses and manufacturing facilities" 
            icon={<Warehouse className="w-6 h-6" />}
            link="/properties?type=industrial"
          />
          <PropertyTypeCard 
            title="Multifamily" 
            description="Apartment buildings and residential complexes" 
            icon={<Home className="w-6 h-6" />}
            link="/properties?type=multifamily"
          />
        </div>
      </div>
    </section>
  );
};

export default PropertyTypes;
